module.exports = __webpack_public_path__ + "img/tree-group.25d64aa.svg";